import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const usePriceOverrideReasonEffect = ({
  filteredProduct,
  storedPriceOverrideReason,
  setPriceOverrideReason,
  priceOverrideReason,
}) => {
  useEffectWithErrorLogging(() => {
    if (
      filteredProduct.some(
        (x) => x.adjustedUsedQtyPrice || x.adjustedOtherQtyPrice
      )
    ) {
      storedPriceOverrideReason
        ? setPriceOverrideReason(storedPriceOverrideReason)
        : setPriceOverrideReason(priceOverrideReason);
    }
  }, [filteredProduct]);
};